// extracted by mini-css-extract-plugin
module.exports = {"player_html_box__nodata":"styles_player_html_box__nodata__3-X09"};